import React, { useEffect, useState } from 'react';
import { RESERVATION_TYPE } from '../../consts/reservation.consts';
import RenderMobileInactive from './render-mobile-inactive';
import { PREVIEW_TYPES } from '../../consts/images.const';
import SpotBreadcrumbs from '../../components/spot-breadcrumbs';
import RenderHostInfo from './render-host-info';
import RenderInactive from './render-inactive';
import SniffCarouselClient from '../../components/carousel';
import RequestMorePhotos from '../../components/request-more-photos';
import SniffCarouselSSR from '../../components/carousel/carousel-ssr';
import RenderSubInfo from './render-sub-info';
import ListingHead from '../../components/listing-head';
import SniffButton from '../../components/sniff-button';
import { AUTH_TESTS } from './auth-test.const';
import { COOKIE_PARAM_NAME } from '../../consts/cookies.consts';
import { SIGN_UP_SRC } from '../../consts/profile.const';
import RenderRating from './render-rating';

const CookieService = require('../../services/cookie.service');

const RenderCarouselServer = ({ spot, myPhotos, useStateSSR, publicPark, toggleMobileGallery }) => (
    <SniffCarouselSSR
        {...{
            item: spot,
            myPhotos,
            useEffect,
            useState,
            lazy: 'eager',
            showArrow: false,
            server: true,
        }}
        onClick={() => toggleMobileGallery(true)}
        spotGallery={!publicPark}
        publicPark={publicPark}
        useStateSSR={useStateSSR}
    />
);

const RenderCarouselClient = ({ spot, myPhotos, useStateSSR, publicPark, handleSwipeMobile, mobilePhotoCount, toggleMobileGallery }) => (
    <SniffCarouselClient
        images={myPhotos}
        type={PREVIEW_TYPES.VIEW}
        disableArrow
        handleSwipeMobile={handleSwipeMobile}
        mobilePhotoCount={mobilePhotoCount}
        onClick={() => toggleMobileGallery(true)}
        spotHost={spot.host}
        spotId={spot.id}
        title={spot.title}
        state={spot.state}
        city={spot.city}
        spot={spot}
        lazy="eager"
        spotGallery={!publicPark}
        publicPark={publicPark}
        useStateSSR={useStateSSR}
    />
);

const RenderHeadMobile = ({
    spot,
    showDisTop,
    setMobilePhotoGallery,
    handleSwipeMobile,
    mobilePhotoCount,
    listBread,
    goToReviews,
    goToHost,
    handleBook,
    handleSniffpassBadge,
    userDetails,
    publicPark,
    handleChangeStars,
    rating,
    setRating,
    spotPhotos,
    useStateSSR,
    setIsBlurTest = () => {},
    isRecentReviewsTest,
}) => {
    const [Carousel, setCarousel] = useState(() => RenderCarouselServer);
    const myPhotos = publicPark ? spot?.allPhotos.map((p) => ({ imageAws: p })) : spotPhotos || spot.spotPhotos;

    const toggleMobileGallery = async (bool = false) => {
        if (!userDetails?.id) {
            const re = `${window.location.pathname}#${AUTH_TESTS.MOBILE_PHOTO_GALLERY}`;

            CookieService.default.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, SIGN_UP_SRC.SPOT_DETAILS_WEB, { expires: 1 });
            CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, re);
            setIsBlurTest(true);
            return;
        }

        setMobilePhotoGallery(bool);
    };

    const CarouselComp = <Carousel {...{ spot, myPhotos, useStateSSR, publicPark, handleSwipeMobile, mobilePhotoCount, toggleMobileGallery }} />;

    useEffect(() => {
        setCarousel(() => RenderCarouselClient);
    }, []);

    return (
        <div className="head">
            <div className="d-block w-100">
                {!publicPark && (!spot.live || spot.host?.id == 0) && (
                    <>
                        {showDisTop && <RenderMobileInactive spot={spot} />}
                        <RenderInactive {...{ spot, useState }} />
                    </>
                )}
                <div className="mobile-carousel">
                    {myPhotos && myPhotos.length > 0 ? (
                        <div className={`spot-main-photo ${useState ? 'carou-ssr' : ''}`}>{CarouselComp}</div>
                    ) : (
                        <div className="spot-main-photo placeholder-photo">
                            <RequestMorePhotos id={spot.id} publicPark={publicPark} />
                        </div>
                    )}
                </div>
                <SpotBreadcrumbs SSR {...{ listBread }} />
                <div className="info w-100">
                    <ListingHead
                        size={spot.size}
                        fncd={spot.enclosureType}
                        title={spot.title || spot.parkName}
                        city={spot.city}
                        state={spot.state}
                        sizeUnits={spot.sizeUnits}
                        distanceFrom={spot.distanceFrom}
                        userDetails={userDetails}
                        address={spot.address}
                        publicPark={publicPark}
                    />
                </div>
                <RenderSubInfo
                    spot={spot}
                    publicPark={publicPark}
                    handleGoTo={goToReviews}
                    handleSniffpassBadge={handleSniffpassBadge}
                    isRecentReviewsTest={isRecentReviewsTest}
                />
                {publicPark && !spot.isReviewed && (
                    <>
                        <RenderRating {...{ handleChangeStars, rating, setRating }} />
                        <div className="my-4">
                            <hr />
                        </div>
                    </>
                )}
                {!publicPark && (
                    <>
                        <RenderHostInfo spot={spot} handleGoTo={goToHost} useState={useState} />
                        <div className="container mt-2">
                            <SniffButton
                                className="mb-2"
                                color="secondary"
                                size="lg"
                                disabled={!spot.live || spot.host?.id == 0}
                                onClick={() => handleBook(RESERVATION_TYPE.CALENDAR)}
                            >
                                Find an available time
                            </SniffButton>
                            <hr />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default RenderHeadMobile;
